import { render } from "./SubjectManage.vue?vue&type=template&id=8ba38f2a"
import script from "./SubjectManage.vue?vue&type=script&lang=js"
export * from "./SubjectManage.vue?vue&type=script&lang=js"

import "./SubjectManage.vue?vue&type=style&index=0&id=8ba38f2a&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__